module.exports = __webpack_public_path__ + "img/null_pedidos.225aa3f5.svg";